var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3376 7.07126C27.9032 7.63685 27.9032 8.55384 27.3376 9.11941L17.0619 19.3951C16.4964 19.9607 15.5794 19.9607 15.0139 19.3951L8.54724 12.9286C7.98165 12.3631 7.98165 11.446 8.54724 10.8805L18.823 0.604738C19.3886 0.0391433 20.3056 0.0391433 20.8711 0.604738L27.3376 7.07126Z",
    fill: "#4A6DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4524 7.07132C20.0179 7.63691 20.0179 8.5539 19.4524 9.11947L9.17667 19.3952C8.61109 19.9607 7.6941 19.9607 7.12851 19.3952L0.661989 12.9287C0.0963942 12.3632 0.0963942 11.4461 0.661989 10.8805L10.9377 0.604799C11.5033 0.0392043 12.4203 0.0392043 12.9859 0.604799L19.4524 7.07132Z",
    fill: "#2EB9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon04);
export default __webpack_public_path__ + "static/media/company-icon-04.46b03145046d18d58a41cfc653f5ef0d.svg";
export { ForwardRef as ReactComponent };